import React from "react";
import {connect} from "react-redux";
import {Route, Switch} from "react-router-dom";
import NotFound from "components/NotFound";

import List from "components/Admin/List";

const mapStateToProps = state => ({
    ...state.admin
});

const mapDispatchToProps = dispatch => ({});

class Admin extends React.Component {
    render() {
        const {match} = this.props;
        const basepath = match.path === "/" ? "" : match.path;

        return (
            <Switch>
                <Route
                    path={`${basepath}/profile/:adminid`}
                    component={NotFound}
                />
                <Route exact path={`${basepath}/`} component={List} />
                <Route exact component={NotFound} />
            </Switch>
        );
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Admin);
